import React from 'react'

import { useTranslation } from 'react-i18next'

import { FilterEntitySelector } from './FilterEntitySelector'
import { FilterFieldSelector } from './FilterFieldSelector'
import { FilterOperatorSelector } from './FilterOperatorSelector'
import { FilterValueInput } from './FilterValueInput'
import { FilterConditionRowProps } from './types'
import { FilterConditionProvider } from './useFilterCondition'
import { Button } from '@/Atomic/Molecules/Button'
import { FormFields } from '@/Atomic/Templates/Form'

/**
 * FilterConditionRow - Main component for a single filter condition
 *
 * Refactored from 892-line monolith into modular components with Context API
 * - Reduced props from 29 to ~11 (context handles the rest internally)
 * - Split into 5 focused subcomponents
 * - Extracted date utilities and types
 * - Logic moved to useFilterCondition hook
 */
export const FilterConditionRow: React.FC<FilterConditionRowProps> = (
  props,
) => {
  const { t } = useTranslation()
  const { condition, groupId, isFirstRow, onRemoveCondition } = props

  return (
    <FilterConditionProvider {...props}>
      <div className="filter-condition-wrapper">
        <FormFields
          className={`filter-condition-row ${isFirstRow ? 'first-row' : ''}`}
        >
          {/* Entity Selector */}
          <FilterEntitySelector />

          {/* Field Selector */}
          <FilterFieldSelector />

          {/* Operator Selector */}
          <FilterOperatorSelector />

          {/* Value Input */}
          <FilterValueInput />

          {/* Action Buttons */}
          <div className="form-field condition-actions">
            <div className="condition-actions-buttons">
              <Button
                variant="icon"
                icon="minus-circle"
                size="sm"
                tabIndex={-1}
                onClick={(e) => onRemoveCondition(groupId, condition.id!, e)}
                ariaLabel={t('common.remove')}
              />
            </div>
          </div>
        </FormFields>
      </div>
    </FilterConditionProvider>
  )
}
